<script setup>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import CaptionProviderCard from '@/components/Captioning/CaptionProviderCard.vue'

// Settings -> Captioning: the account's own SyncWords captioning account.
// Same gating as the other developer-level tabs; core enforces it too.
const store = useStore()

const canAccessDevelopers = computed(() => store.getters['User/canAccessDevelopers'])
const userEmail = computed(() => store.getters['User/userEmail'])
const userloaded = computed(() => store.getters['User/userLoaded'])

onMounted(() => {
  window.trackEvent?.('Page Viewed', { page: 'Captioning Settings' })
})
</script>

<template>
  <div class="view">
    <div v-if="canAccessDevelopers && userloaded" class="lg:w-1/2">
      <CaptionProviderCard />
    </div>
    <div v-else-if="userloaded" class="text-center mt-6 lg:mt-12">
      <h4 class="text-surface-9 text-lg font-medium">You don’t have permission to access this.</h4>
      <p class="text-surface-6 text-base">Contact the team owner at <a class="text-surface-6 underline"
          :href="'mailto:' + userEmail">{{ userEmail }}</a> to gain access.</p>
    </div>
  </div>
</template>
